'use es6';

import LanguageName from 'EmailComponents/LanguageName';
import RssUrlField from 'EmailComponents/RssUrlField';
import * as blogsApi from 'EmailData/api/blogs';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UISelect from 'UIComponents/input/UISelect';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import PropTypes from 'prop-types';
import { Component } from 'react';
import debounce from 'react-utils/debounce';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RenderMaybeLockedRadio = ({
  canUseRss,
  onSelectExternalRssFeed,
  isRssFeedSelected,
  messageText
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('email-blog-rss-sends');
  return /*#__PURE__*/_jsxs(RadioInput, {
    name: "externalBlog",
    checked: isRssFeedSelected,
    inline: true,
    onChange: canUseRss ? onSelectExternalRssFeed : openUpgradeModal,
    size: "small",
    "data-test-id": "rss-email-radio",
    marginInlineStart: "200",
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: messageText
    }), !canUseRss && /*#__PURE__*/_jsx(LockBadge, {})]
  });
};
class BlogRssFeedSelectModalBody extends Component {
  constructor(props) {
    super(props);
    this.onSelectBlog = this.onSelectBlog.bind(this);
    this.onSelectRssFeedUrl = this.onSelectRssFeedUrl.bind(this);
    this.renderRssFeedUrl = this.renderRssFeedUrl.bind(this);
    this.onSelectExternalRssFeed = this.onSelectExternalRssFeed.bind(this);
    this.searchForBlogDebounced = debounce(this.searchForBlog.bind(this), 200);
    this.renderHubspotBlogSelect = this.renderHubspotBlogSelect.bind(this);
    this.renderRadioOptions = this.renderRadioOptions.bind(this);
    this.getIsRssFeedSelected = this.getIsRssFeedSelected.bind(this);
    this.onSelectHubspotBlogs = this.onSelectHubspotBlogs.bind(this);
    this.onSelectFrequency = this.onSelectFrequency.bind(this);
  }
  getIsRssFeedSelected() {
    return this.props.selectedBlog === -1;
  }
  searchForBlog(input, callback) {
    const {
      canAccessBusinessUnit,
      businessUnitId
    } = this.props;
    if (canAccessBusinessUnit && ![undefined, null, ''].includes(businessUnitId)) {
      // eslint-disable-next-line promise/catch-or-return
      blogsApi.getBusinessUnitBlogs(input, businessUnitId).then(blogs => {
        callback(null, this.renderBlogsAsOptions(blogs));
      }, callback);
    } else {
      // eslint-disable-next-line promise/catch-or-return
      blogsApi.get(input).then(blogs => {
        callback(null, this.renderBlogsAsOptions(blogs));
      }, callback);
    }
  }
  onSelectBlog(e) {
    this.props.onSelectBlog(e.target.value);
  }
  onSelectFrequency(e) {
    this.props.onSelectFrequency(e.target.value);
  }
  onSelectExternalRssFeed() {
    this.props.onSelectBlog(-1);
  }
  onSelectHubspotBlogs() {
    this.props.onSelectBlog(null);
  }
  onSelectRssFeedUrl(e) {
    this.props.onSelectRssFeedUrl(e.target.value);
  }
  getBlogNameAndLanguage(blog) {
    return /*#__PURE__*/_jsxs("span", {
      children: [blog.name, " ", /*#__PURE__*/_jsx(LanguageName, {
        languageKey: blog.language
      })]
    });
  }
  renderRssFeedUrl() {
    return /*#__PURE__*/_jsx(RssUrlField, {
      inputSize: 11,
      value: this.props.rssFeedUrl,
      onChange: this.onSelectRssFeedUrl,
      onSelectBlog: this.onSelectBlog
    });
  }
  renderBlogsAsOptions(blogs) {
    if (!blogs || !blogs.objects) {
      return {
        options: []
      };
    }
    return {
      options: blogs.objects.map(blog => ({
        text: this.getBlogNameAndLanguage(blog),
        value: blog.id
      }))
    };
  }
  renderFrequencyOption(freq) {
    return {
      text: I18n.text(`EmailComponents.modals.creation.blogRss.frequencySelect.options.${freq}`),
      value: freq
    };
  }
  renderRadioOptions() {
    const {
      canUseRss
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      "data-selenium": "blog-source-selects",
      "data-test-id": "blog-source-selects",
      children: [/*#__PURE__*/_jsx(FormLabel, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "EmailComponents.modals.creation.blogRss.feedSourceSelect"
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(RadioInput, {
          name: "hubspotBlogs",
          checked: !this.getIsRssFeedSelected(),
          inline: true,
          onChange: this.onSelectHubspotBlogs,
          size: "small",
          "data-test-id": "blog-email-radio",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.modals.creation.blogRss.hubspotBlog"
          })
        }), /*#__PURE__*/_jsx(RenderMaybeLockedRadio, {
          canUseRss: canUseRss,
          onSelectExternalRssFeed: this.onSelectExternalRssFeed,
          isRssFeedSelected: this.getIsRssFeedSelected(),
          messageText: "EmailComponents.modals.creation.blogRss.externalBlog"
        })]
      })]
    });
  }
  renderHubspotBlogSelect() {
    const {
      selectedBlog,
      selectedFrequency
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      "data-test-id": "blog-feed-select",
      children: [/*#__PURE__*/_jsx(FormControl, {
        required: true,
        label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "EmailComponents.modals.creation.blogRss.blogSelect"
        }),
        maxInlineSize: "400px",
        children: /*#__PURE__*/_jsx(UISelect, {
          "data-test-id": "blog-ui-select",
          "data-selenium": "blog-feed-select",
          value: selectedBlog,
          loadOptions: this.searchForBlogDebounced,
          filterOptions: false,
          placeholder: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.modals.creation.blogRss.selectPlaceholder"
          }),
          onChange: this.onSelectBlog
        })
      }), selectedBlog && /*#__PURE__*/_jsx(FormControl, {
        required: true,
        label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "EmailComponents.modals.creation.blogRss.frequencySelect.title"
        }),
        maxInlineSize: "400px",
        children: /*#__PURE__*/_jsx(UISelect, {
          "data-test-id": "blog-frequency-select",
          "data-selenium": "blog-frequency-select",
          value: selectedFrequency,
          filterOptions: false,
          options: ['instant', 'daily', 'weekly', 'monthly'].map(this.renderFrequencyOption),
          placeholder: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.modals.creation.blogRss.selectFrequencyPlaceholder"
          }),
          onChange: this.onSelectFrequency
        })
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "blog-rss-feed-select-modal-body",
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          children: this.props.canUseRss ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `EmailComponents.modals.creation.chooseEmailType.description.create.BLOG_RSS`
          }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `EmailComponents.modals.creation.chooseEmailType.description.create.BLOG`
          })
        }), this.renderRadioOptions(), this.getIsRssFeedSelected() ? this.renderRssFeedUrl() : this.renderHubspotBlogSelect()]
      })
    });
  }
}
BlogRssFeedSelectModalBody.propTypes = {
  selectedBlog: PropTypes.number,
  selectedFrequency: PropTypes.string,
  rssFeedUrl: PropTypes.string,
  onSelectBlog: PropTypes.func.isRequired,
  onSelectRssFeedUrl: PropTypes.func.isRequired,
  onSelectFrequency: PropTypes.func.isRequired,
  canUseRss: PropTypes.bool.isRequired,
  canAccessBusinessUnit: PropTypes.bool.isRequired,
  businessUnitId: PropTypes.number
};
export default BlogRssFeedSelectModalBody;